const ROUTE_KEY_MAX_LENGTH = 100;
const AUTO_STAGE_ROUTE_KEY_SUFFIX = 'auto';

const sanitizeRouteKey = (value: string): string => (
  value
    .trim()
    .replace(/[^A-Za-z0-9_-]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^[-_]+|[-_]+$/g, '')
);

export const normalizeRouteKey = (value: unknown, fallback: string): string => {
  const fallbackKey = sanitizeRouteKey(fallback) || 'key';
  let key = sanitizeRouteKey(String(value ?? ''));

  if (!key) {
    key = fallbackKey;
  }

  if (!/^[A-Za-z]/.test(key)) {
    key = `${fallbackKey}-${key}`;
  }

  return key.slice(0, ROUTE_KEY_MAX_LENGTH);
};

export const makeUniqueRouteKey = (value: unknown, fallback: string, usedKeys: Set<string>): string => {
  const baseKey = normalizeRouteKey(value, fallback);
  let key = baseKey;
  let index = 2;

  while (usedKeys.has(key)) {
    const suffix = `-${index}`;
    key = `${baseKey.slice(0, ROUTE_KEY_MAX_LENGTH - suffix.length)}${suffix}`;
    index += 1;
  }

  usedKeys.add(key);

  return key;
};

export const getRecipientRouteKey = (
  recipient: {
    boxEmail?: string | null;
    boxId?: string | null;
    boxPhone?: string | null;
    guestEmail?: string | null;
    recipientKey?: string | null;
    signer?: { fullName?: string | null } | null;
  },
  index: number,
  usedKeys: Set<string>
): string => (
  makeUniqueRouteKey(
    recipient.recipientKey ||
      recipient.boxEmail ||
      recipient.guestEmail ||
      recipient.boxId ||
      recipient.boxPhone ||
      recipient.signer?.fullName,
    `recipient${index + 1}`,
    usedKeys
  )
);

export const getStageRouteKey = (
  stageKey: unknown,
  index: number,
  usedKeys: Set<string>
): string => (
  makeUniqueRouteKey(stageKey, getAutoStageRouteKey(index), usedKeys)
);

export const getAutoStageRouteKey = (index: number): string => (
  `stage${index + 1}${AUTO_STAGE_ROUTE_KEY_SUFFIX}`
);
